import React, { useEffect } from 'react';
import headerImage from '../../assets/headerImg.jpg';

export const PageHeader = () => {
  useEffect(() => {
    const elementsUp = document.querySelectorAll('.goesUp');
    const elementsDown = document.querySelectorAll('.goesDown');

    // Initial animation
    elementsUp.forEach(el => {
      el.style.transform = 'translateY(-100%) scaleY(-1) scaleX(-1)';
      setTimeout(() => {
        el.style.transition = 'transform 0.5s ease-out';
        el.style.transform = 'translateY(0) scaleY(-1) scaleX(-1)';
      }, 100);
    });

    elementsDown.forEach(el => {
      el.style.transform = 'translateY(100%) scaleY(-1) scaleX(-1)';
      setTimeout(() => {
        el.style.transition = 'transform 0.5s ease-out';
        el.style.transform = 'translateY(0) scaleY(-1) scaleX(-1)';
      }, 100);
    });

    // Scroll event listener
    const handleScroll = () => {
      const scrollDirection = window.scrollY > (window.prevScrollY || 0) ? 'down' : 'up';
      window.prevScrollY = window.scrollY;

      if (scrollDirection === 'down') {
        elementsUp.forEach(el => {
          el.style.transform = 'translateY(-20%) scaleY(-1) scaleX(-1)';
        });
        elementsDown.forEach(el => {
          el.style.transform = 'translateY(20%) scaleY(-1) scaleX(-1)';
        });
      } else {
        elementsUp.forEach(el => {
          el.style.transform = 'translateY(0) scaleY(-1) scaleX(-1)';
        });
        elementsDown.forEach(el => {
          el.style.transform = 'translateY(0) scaleY(-1) scaleX(-1)';
        });
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleWebSiteClick = () => {
    window.open('https://selfadhesives.fedrigoni.com/product/luxury-labels/', '_blank', 'noopener,noreferrer');
  };

  return (
    <div>
      <div style={{position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'white', background: '#25242D', padding: '16px', gap: '4px'}}>
        <div style={{fontSize: '30px', fontWeight: 700, marginBottom: '10px'}}>
          MANTER
        </div>
        <div style={{position: 'absolute', top: '92px', fontWeight: 700, fontSize: '10.5px', lineHeight: '13px', textAlign: 'center'}}>
          POCKET <br /> COLLECTION
        </div>
        <div style={{display: 'flex', alignItems: 'flex-end', overflow: 'hidden'}}>
          <div className="goesUp" style={{writingMode: 'vertical-rl', textOrientation: 'mixed', transform: 'scaleY(-1) scaleX(-1)', fontSize: '90px', fontWeight: '700', color: '#C8C8C8', lineHeight: '90px'}}>
            THE ART OF
          </div>
          <div className="goesDown" style={{writingMode: 'vertical-rl', textOrientation: 'mixed', transform: 'scaleY(-1) scaleX(-1)', fontSize: '90px', fontWeight: '700', color: '#C8C8C8', lineHeight: '90px'}}>
            LUXURY
          </div>
          <div className="goesUp" style={{writingMode: 'vertical-rl', textOrientation: 'mixed', transform: 'scaleY(-1) scaleX(-1)', fontSize: '90px', fontWeight: '700', color: '#C8C8C8', lineHeight: '90px'}}>
            LABELLING
          </div>
        </div>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '18px'}}>
          <div style={{fontWeight: 700, fontSize: '24px', textAlign: 'center'}}>
            FEDRIGONI
          </div>
          <div style={{fontWeight: 400, fontSize: '10.5px', lineHeight: '13px', textAlign: 'center'}}>
            SELF-ADHESIVES
          </div>
        </div>
        <div>
        <svg width="18" height="3" viewBox="0 0 18 3" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.0229492" y="0.75354" width="17.9546" height="1.93042" fill="white"/>
        </svg>
        </div>
        <div style={{fontWeight: 700, fontSize: '10.5px', lineHeight: '13px', textAlign: 'center', marginTop: '4px', marginBottom: '10px'}}>
          EXPERIENCE
        </div>
      </div>
      <img width="100%" src={headerImage} alt="wallImage" />
      <div style={{display: 'flex', flexDirection: 'column', padding: '16px 24px', alignItems: 'flex-start', gap: '19px'}}>
        <div style={{fontWeight: 700, fontSize: '20px', fontStyle: 'bold'}}>
          Simply beautiful labels
        </div>
        <div style={{fontWeight: 400, fontSize: '18px', lineHeight: '20px', textAlign: 'left'}}>
          Luxury, sustainability and design: three words that have always been used to describe Manter, the Spanish company specializing in the production of adhesive papers, which joined the Fedrigoni Group in 1993.
          <br /><br />
          Manter combines beautiful self-adhesive materials, paper and films for the labeling sector, providing a comprehensive range of materials for designers looking for the best for their creations.
        </div>
        <div onClick={handleWebSiteClick} style={{background: '#25242D', padding: '16px', color: 'white', width: '100%', boxSizing: 'border-box', marginTop: '10px', fontWeight: 700, fontSize: '20px', fontStyle: 'bold', cursor: 'pointer'}}>
          Visit website
        </div>
        <div style={{fontSize: '32px', marginTop: '30px', textAlign: 'left', borderBottom: '1px solid black', padding: '0px 0px 20px'}}>
          Turning Our Paper Into Luxury Labels
        </div>
      </div>
    </div>
  );
}